<template lang="pug">
    .component-backoffice-home


</template>

<script type="text/babel">
    export default {
        name: "BackofficeLogout",
        components: {},
        created() {
            localStorage.removeItem('backoffice-token');
            location.reload()
        },
        methods: {},
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .login-error-message
        color: #be2626
        font-weight: 900
</style>



// WEBPACK FOOTER //
// Logout.vue?743a0492